export class IroningModel {
  name: string;
  minPrice: number;
  maxPrice?: number;
  constructor(name: string, minPrice: number, maxPrice: number) {
    this.name = name;
    this.minPrice = minPrice;
    this.maxPrice = maxPrice;
  }
}
